module.exports = __webpack_public_path__ + "static/media/quiz-04.fef83681.jpg";